import React from 'react';
import { FormProvider } from 'react-hook-form';
import { useGuestBookingForm } from './hooks/useGuestBookingForm';
import { Row } from './layout/Row';
import { GuestBookingFormActions as FormActions } from './GuestBookingFormActions';
import { IGuestBookingFormData } from './types/IGuestBookingFormData';
import { Reference } from './fields/ReferenceField';
import { Email } from '../../../../auth/shared/form-fields/Email';

interface IGuestBookingFormProps {
	onSubmit: (data: IGuestBookingFormData) => Promise<void> | void;
	submitButtonText: string;
}

export const GuestBookingForm = ({
	onSubmit,
	submitButtonText,
}: IGuestBookingFormProps) => {
	const form = useGuestBookingForm();

	return (
		<FormProvider {...form}>
			<form noValidate onSubmit={form.handleSubmit(onSubmit)}>
				<Row>
					<Reference />
				</Row>
				<Row>
					<Email />
				</Row>
				<FormActions submitButtonText={submitButtonText} />
			</form>
		</FormProvider>
	);
};
